import { render, staticRenderFns } from "./InfoImportante.vue?vue&type=template&id=273c86ba&"
import script from "./InfoImportante.vue?vue&type=script&lang=js&"
export * from "./InfoImportante.vue?vue&type=script&lang=js&"
import style0 from "./InfoImportante.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports